import { Grid, useAppSelector, RootState } from '../../../../base';
import { JobRequirementsAndBenefitsContent } from '../../../JobCommonComponents';
import { JobOverviewContent } from '../../../JobCommonComponents';
import JobStepsViewer from '../../../JobCommonComponents/JobStepsViewer';
import JobQuestionsViewer from '../../../JobCommonComponents/JobQuestionsViewer';
import { organizationSelectors } from '../../../../actions';
import { FeatureFlags } from '../../../../common';

const SaveJobPreview = () => {
    const isCandidateQuestionsFeatureFlagOn = useAppSelector(
        (state: RootState) =>
            organizationSelectors.isFlagOn(
                state,
                FeatureFlags.CANDIDATE_QUESTIONS
            )
    );

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <JobOverviewContent isPreview={true} />
            </Grid>
            <Grid item xs={6}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <JobStepsViewer isPreview={true} />
                    </Grid>
                    <Grid item xs={12}>
                        <JobRequirementsAndBenefitsContent isPreview={true} />
                    </Grid>
                    {isCandidateQuestionsFeatureFlagOn && (
                        <Grid item xs={12}>
                            <JobQuestionsViewer isPreview={true} />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SaveJobPreview;
